import {EventMinicart} from '_types'
import {analyticsLogEvent} from '../api'

const eventName = 'addToCartFromMinicart'

interface Parameters {
    name: string
    masterId: string
    price: number
    categoryPath: string
    gender: string
    color: {
        code: string
        label: string
    }
    size: {
        code: string
        label: string
    }
    hasDiscount: boolean
    currencyCode: string
}

/**
 * Tracks a product quantity increase triggered by the user in the minicart.
 *
 * @param {Parameters} params - Object containing the product details.
 * @param {string} params.name - The product's short description in english.
 * @param {string} params.masterId - The id of the product's master.
 * @param {number} params.price - The product's price.
 * @param {string} params.categoryPath - The product's analytics category path.
 * @param {string} params.gender - The product's gender in english.
 * @param {Object} params.color - The product's color details in english.
 * @param {Object} params.size - The product's size details.
 * @param {boolean} params.hasDiscount - Whether or not the product's price is discounted.
 * @param {string} params.currencyCode - The currency code being used.
 *
 */
export function analyticsEventMinicartAddToCart({name, masterId, price, categoryPath, gender, color, size, hasDiscount, currencyCode}: Parameters): void {
    const eventDetails: EventMinicart = {
        ecommerce: {
            currencyCode: currencyCode,
            add: {
                products: [
                    {
                        name: name,
                        id: masterId,
                        price: price.toFixed(2).toString(),
                        category: categoryPath,
                        variant: color.code,
                        color: color.label,
                        gender: gender,
                        dimension21: size.label,
                        dimension22: 'minicart',
                        dimension26: hasDiscount,
                        quantity: '1',
                    },
                ],
            },
        },
    }

    analyticsLogEvent(eventName, eventDetails)
}
